import {initWebComponent} from "@/helpers/web-component-helper";
import {
    activateUserSessionByID,
    getUserSessionByID,
    removeUserSession,
    updateSession
} from "@/helpers/user-session-helper";
import Swal from "sweetalert2";

export class BookmarkUserSessionRemoveButtonComponent extends HTMLElement {
    constructor(){
        super();

        const id = this.getAttribute('data-id')

        const template = document.createElement('template');

        template.innerHTML = `<button class="btn btn-sm borderless icon-btn popper-header">
              <i class="fa fa-times"></i>
              <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                 Bookmark verwijderen
                <div class="arrow" data-popper-arrow=""></div>
              </div>
            </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {

            const userSession = getUserSessionByID(id)

            console.log(userSession)

            Swal.fire({
                buttonsStyling: false,
                title: 'Weet u het zeker?',
                html: `De bookmark <b>${userSession.Name}</b> wordt verwijderd`,
                type: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-danger float-right',
                    cancelButton: 'btn btn-outline-secondary float-left'
                },
                reverseButtons: true,
                confirmButtonText: '<span class="fa fa-trash"></span> Verwijderen',
                cancelButtonText: "Annuleren",
            }).then((result) => {
                if (result.value) {
                    removeUserSession(id)
                    this.closest('.card').remove()
                }
            })
        })
    }
}
